import {EonUiLink} from "@eon-ui/eon-ui-components-react";
import React from "react";
import {LikeOrDislike} from "@me8eon/feedback";

type Props = {
    type: LikeOrDislike;
    value: LikeOrDislike | undefined;
    onClick: () => void;
    label?: string;
    disabled: boolean;
};

export function FeedbackButton({ value, type, onClick, label, disabled }: Props) {
    const isSelected = value === type;
    return (
        <div className="like-dislike">
            <EonUiLink
                className={`thumb ${isSelected ? "thumb--selected" : ""} ${type === "like" ? "up" : "down"}`}
                onClick={onClick}
                icon="thumb_up"
                iconPosition="left"
                size="small"
                disabled={disabled}
                scheme={isSelected ? (disabled ? "neutral100" : "red500") : "neutral800"}
            ></EonUiLink>
            {label && <span className="title cursor-pointer" onClick={onClick}>{label}</span>}
        </div>
    );
}